import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

interface DomainMigrationBannerContextValue {
  visible: boolean;
  close: () => void;
}

const DomainMigrationBannerContext = createContext<DomainMigrationBannerContextValue>({
  visible: false,
  close: (): void => {},
});

interface BannerProviderProps {
  children: ReactNode;
}

export function BannerProvider({ children }: BannerProviderProps) {
  const [visible, setVisible] = useState<boolean>(() => window.location.hostname.endsWith('mer.eco'));

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const value = useMemo(() => ({ visible, close }), [visible, close]);

  return <DomainMigrationBannerContext.Provider value={value}>{children}</DomainMigrationBannerContext.Provider>;
}

export const useBanner = (): DomainMigrationBannerContextValue => useContext(DomainMigrationBannerContext);
